import { useAppContext } from '../context/AppContext';

export function useInstallPrompt() {
  const { state, dispatch } = useAppContext();
  const prompt = state.installPromptEvent;

  async function triggerInstall() {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    dispatch({ type: 'SET_INSTALL_PROMPT', event: null });
  }

  return { canInstall: !!prompt, triggerInstall };
}
